let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hn8O3")).then(() => parcelRequire('1hPWF'));